module.exports = __webpack_public_path__ + "static/img/team_honor_yajun.b6a6f62c.png";